(() => {
  const config = document.querySelector('script[data-visitor-language]');
  const form = document.getElementById('ValkyriaVisitorLanguage');
  if (!config || !form) return;

  const choiceKey = 'vl_language_choice';
  const visitKey = 'vl_language_checked';
  const readChoice = () => {
    try {
      const choice = localStorage.getItem(choiceKey);
      if (choice) return choice;
    } catch {}
    return document.cookie.split('; ').find((entry) => entry.startsWith(`${choiceKey}=`))?.split('=')[1];
  };
  const rememberChoice = (language) => {
    if (!/^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/i.test(language || '')) return;
    try {
      localStorage.setItem(choiceKey, language);
    } catch {}
    document.cookie = `${choiceKey}=${encodeURIComponent(language)}; Path=/; Max-Age=31536000; SameSite=Lax; Secure`;
  };

  document.addEventListener('click', (event) => {
    const option = event.target.closest('localization-form a[hreflang][data-value]');
    if (option) rememberChoice(option.dataset.value);
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target === form || !event.target.matches('localization-form form')) return;
    const input = event.target.querySelector('[name="language_code"], [name="locale_code"]');
    if (input) rememberChoice(input.value);
  }, true);

  const url = new URL(window.location.href);
  if (
    readChoice() || config.dataset.language !== 'en' || config.dataset.root !== '/' ||
    Number(config.dataset.cartCount) > 0 ||
    /^\/(?:account|cart|checkout|checkouts|en)(?:\/|$)/.test(url.pathname) ||
    ['locale', 'language', 'language_code', 'country'].some((key) => url.searchParams.has(key))
  ) return;

  try {
    if (sessionStorage.getItem(visitKey)) return;
    sessionStorage.setItem(visitKey, '1');
  } catch {
    return;
  }

  let interacted = false;
  const stopDefault = () => { interacted = true; };
  document.addEventListener('pointerdown', stopDefault, { once: true, capture: true });
  document.addEventListener('keydown', stopDefault, { once: true, capture: true });

  fetch(`${config.dataset.root}browsing_context_suggestions.json?country[enabled]=true`, {
    credentials: 'same-origin',
    signal: AbortSignal.timeout(2500),
  })
    .then((response) => response.ok ? response.json() : null)
    .then((context) => {
      if (context?.detected_values?.country?.handle !== 'DK' || interacted || readChoice()) return;
      const returnTo = form.querySelector('[name="return_to"]');
      if (returnTo) returnTo.value = `${url.pathname}${url.search}${url.hash}`;
      form.submit();
    })
    .catch(() => {})
    .finally(() => {
      document.removeEventListener('pointerdown', stopDefault, true);
      document.removeEventListener('keydown', stopDefault, true);
    });
})();
